import React from 'react';
import VacationRequestForm from '../VacationRequestForm';

function OperationalRequestEntrySection({
  canSubmit = false,
  currentManager = null,
  disabledMessage = '',
  helperContent = null,
  onSubmitted = () => {},
  scopeCode = '',
  submitCopy = '',
  title = 'Request Time Off'
}) {
  return (
    <div className="role-section">
      <div className="role-section-header">
        <h2>{title}</h2>
        <span>{scopeCode}</span>
      </div>
      {canSubmit ? (
        <>
          <p className="role-section-copy">
            {submitCopy}
          </p>
          {helperContent}
          <VacationRequestForm
            currentManager={currentManager}
            onSubmitted={onSubmitted}
            title="Request Vacation Time"
          />
        </>
      ) : (
        <p className="role-section-copy">
          {disabledMessage}
        </p>
      )}
    </div>
  );
}

export default OperationalRequestEntrySection;
